// index.tsx (UI-only)
import React from 'react'
import { Flex, Image, Layout, Spin } from 'antd'
import { CenteredContainer, HeaderText, NoScansToUpload } from './index.styled'
import { ScanUploadModal } from './ScanUploadModel/ScanUploadModel'
import { useScan } from './useScan'
import AppointmentRow from '../../../components/AppointmentCard/AppointmentCard'
import LogoBadgeOutlined from '../../../images/LogoBadgeOutlined.png'
import logout from '../../../images/logout.svg'

export default function Scan() {
  const { Header, Content } = Layout

  const { todayScan, todayScanStatus, currentScanUpload, handleSelect, signOut, APIStatus } = useScan()

  // ---------------------------------------
  // 1. Loading State
  // ---------------------------------------
  if (todayScanStatus === APIStatus.pending) {
    return (
      <div
        style={{ height: '100vh', width: '100vw', overflow: 'hidden', touchAction: 'none', WebkitUserSelect: 'none' }}
      >
        <Layout style={{ width: '100%', height: '100%' }}>
          <Header
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid #13152D',
              position: 'fixed',
              width: '100%',
              paddingLeft: 30,
              paddingRight: 12,
            }}
          >
            <Image preview={false} src={LogoBadgeOutlined} style={{ width: '40px', height: '40px' }}></Image>
            <div style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }} onClick={signOut}>
              <img src={logout} />
              <div style={{ marginLeft: '8px', color: '#007f7c', fontSize: '16px', fontWeight: 600 }}>Logout</div>
            </div>
          </Header>

          <Content
            style={{
              backgroundColor: 'var(--color-bg)',
              padding: '20px 48px',
              position: 'fixed',
              width: '100%',
              top: 100,
              height: '100%',
              display: 'flex',
              gap: '80px',
            }}
          >
            <CenteredContainer>
              <Spin />
            </CenteredContainer>
          </Content>
        </Layout>
      </div>
    )
  }

  // ---------------------------------------
  // 2. Empty scan list
  // ---------------------------------------
  if (todayScan && todayScan.length === 0) {
    return (
      <Layout style={{ width: '100%', height: '100%' }}>
        <div style={{ height: '100vh', width: '100vw' }}>
          <Layout style={{ width: '100%', height: '100%' }}>
            <Header
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: '1px solid #13152D',
                position: 'fixed',
                width: '100%',
                paddingLeft: 30,
                paddingRight: 12,
              }}
            >
              <Image preview={false} src={LogoBadgeOutlined} style={{ width: '40px', height: '40px' }}></Image>
              <div style={{ display: 'flex', cursor: 'pointer' }} onClick={signOut}>
                <img src={logout} />
                <div style={{ marginLeft: '8px', color: '#007f7c', fontSize: '16px', fontWeight: 600 }}>Logout</div>
              </div>
            </Header>

            <Content
              style={{
                backgroundColor: 'var(--color-bg)',
                padding: '20px 48px',
                position: 'fixed',
                width: '100%',
                top: 100,
                height: '100%',
              }}
            >
              <NoScansToUpload>No scans available for upload</NoScansToUpload>
            </Content>
          </Layout>
        </div>
      </Layout>
    )
  }

  // ---------------------------------------
  // 3. Default view
  // ---------------------------------------
  return (
    <div style={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Layout style={{ width: '100%', height: '100%' }}>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottom: '1px solid var(--color-border-primary)',
            position: 'fixed',
            width: '100%',
            paddingLeft: 30,
            paddingRight: 12,
          }}
        >
          <Image preview={false} src={LogoBadgeOutlined} style={{ width: '40px', height: '40px' }}></Image>
          <div style={{ display: 'flex', cursor: 'pointer' }} onClick={signOut}>
            <img src={logout} />
            <div style={{ marginLeft: '8px', color: '#007f7c', fontSize: '16px', fontWeight: 600 }}>Logout</div>
          </div>
        </Header>

        <Content
          style={{
            backgroundColor: 'var(--color-bg)',
            padding: '20px 48px',
            position: 'fixed',
            width: '100%',
            top: 100,
            height: '100%',
            display: 'flex',
            gap: '80px',
          }}
        >
          <Flex vertical gap={8} style={{ width: '48%' }}>
            <HeaderText>Patients | {todayScan?.length ?? 0}</HeaderText>

            <Flex vertical gap={8} style={{ overflowY: 'auto', padding: '2px', height: '100%', paddingBottom: 120 }}>
              {todayScan?.map((card: any) => (
                <AppointmentRow
                  key={card.id}
                  name={(card.patient.user.firstname || '-') + ' ' + (card.patient.user.lastname ?? '-')}
                  avatar={card.patient.user.profilePic}
                  onClick={() => handleSelect(card)}
                  cardStyle={{
                    outline: currentScanUpload?.visitId === card.id ? '1px solid #000000' : '1px solid transparent',
                    outlineOffset: '-1px',
                    cursor: 'pointer',
                  }}
                />
              ))}
            </Flex>
          </Flex>

          <Flex style={{ width: '48%' }}>
            <ScanUploadModal patientInfo={currentScanUpload} />
          </Flex>
        </Content>
      </Layout>
    </div>
  )
}
